import { ColProps, DatePicker, Form } from "antd";
import { ReactNode } from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface Props<TSchema extends FieldValues> {
  name: Path<TSchema>; // Allow only field names (string) that are listed into the Schema
  label: ReactNode;
  errorMessage?: string;
  control: Control<TSchema>;
  labelCol?: ColProps | undefined;
  wrapperCol?: ColProps | undefined;
  isVertical?: boolean;
}

export default function FieldDate<TSchema extends FieldValues>(
  props: Props<TSchema>,
) {
  const {
    name,
    label,
    errorMessage,
    control,
    labelCol,
    wrapperCol,
    isVertical,
  } = props;

  return (
    <Form.Item
      validateStatus={errorMessage ? "error" : ""}
      help={errorMessage || null}
      label={label}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      layout={isVertical ? "vertical" : "horizontal"}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <DatePicker
            {...field}
            value={field.value || null}
            placeholder="Date"
            format="DD/MM/YYYY"
          />
        )}
      />
    </Form.Item>
  );
}
